import * as React from 'react';
import { getAppHost } from '../../utilities/TeamsUtils';
import { FormFacade } from '../facade';
import { useFormFacadeProps } from '../hooks';
import { FormMode } from '../implementations';
import { noop } from '../shims';
import { parseFormTemplate } from '../utils';

export interface TemplatePreviewAdapterProps extends React.HTMLAttributes<HTMLDivElement> {
    formTemplate: string;
    onFormReady?: () => void;
}

export const TemplatePreviewAdapter: React.FC<TemplatePreviewAdapterProps> = ({
    formTemplate,
    onFormReady = noop,
    ...props
}) => {
    const formFacadeProps = useFormFacadeProps({ compact: getAppHost().isMobile() });
    const context = React.useMemo(
        () => ({ mode: FormMode.Previewing, entries: parseFormTemplate(formTemplate) }),
        [formTemplate]
    );

    const onFormReadyRef = React.useRef(onFormReady);
    React.useEffect(() => onFormReadyRef.current(), []);

    return <FormFacade {...formFacadeProps} {...props} context={context} />;
};
